module.exports = __webpack_public_path__ + "img/blogs_layout4.085be71f.png";